// @flow
import React, {useEffect, useState} from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import {usePrevious} from '../../utils/react';

type Props = {
  mode: 'error' | 'success' | 'warning' | 'info',
  message?: string,
  duration?: number,
  className?: string,
  handleClose?: () => void,
};

export default function SnackBar(props: Props) {
  const {mode, message, duration, className, handleClose} = props;
  const [open, setOpen] = useState(false);
  const prevMessage = usePrevious(message);

  // const handleClose = () => setOpen(false);

  useEffect(() => {
    if (!prevMessage && message) {
      setOpen(true);
    }
    if (prevMessage && !message) {
      setOpen(false);
    }
  }, [prevMessage, message]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration ? duration : 3000}
      onClose={handleClose ? handleClose : () => setOpen(false)}
    >
      <MuiAlert
        // elevation={6}
        variant="filled"
        onClose={handleClose ? handleClose : () => setOpen(false)}
        severity={mode ? mode : 'success'}
        className={`${className ? className : ''}`}
      >
        {message || prevMessage}
      </MuiAlert>
    </Snackbar>
  );
}
